import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeIdentifierListScreen from './screens/ChargeIdentifierListScreen';

function ChargeIdentifier(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeIdentifierListScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeIdentifier;
